import actionTypes from '../webActionTypes';
import GLOBAL from '../../jcolorglobal';
// import * as webActions from './webActions';

const CHECK_LOGIN_API_URL = '/AdminAction.do?op=checkLogin';
const LOGIN_API_URL = '/AdminAction.do?op=login';
const LOGOUT_API_URL = '/AdminAction.do?op=logout';

// var didCheckLogin = false;

// begin check member login sync action creator
function beginCheckAdminLogin(payload) {
    return { type: actionTypes.beginCheckAdminLogin, payload };
}

function setAdminLoginInfo(admininfo) {

    var payload = {
        admininfo,
    }

    return { type: actionTypes.setAdminLoginInfo, payload };

}

// check member login error
function recvCheckAdminLoginError(payload) {
    return { type: actionTypes.recvCheckAdminLoginError, payload };
}

// check member login thunk
function checkAdminLogin(payload = {}) {
    return dispatch => {

        dispatch(beginCheckAdminLogin(payload)); // dispatch synced action to update loading status

        const promise = new Promise((resolve, reject) => {

            GLOBAL.fetchWithCookies(CHECK_LOGIN_API_URL)
                .then(response => {
                    
                    if (response.status === 503) {
                        // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                        reject({
                            error: 'error.503error',
                            message: '伺服器沒有開啟'
                        });

                        return;
                    }

                    response
                        .json()
                        .then(result => {
                            if (!result) {
                                reject();
                                return;
                            }

                            if(result.error) {
                                reject(result.error);
                                return 
                            }

                            dispatch(setAdminLoginInfo(result));
                            resolve(result);
                        })
                        .catch(error => {
                            dispatch(recvCheckAdminLoginError(error));
                            reject(error);
                        });
                })
                .catch(error => {
                    // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                    dispatch(recvCheckAdminLoginError(error));
                    reject(error);
                });
        });

        return promise;

    };
}

function login(adminid, passwd, token) {
    return dispatch => {
        const promise = new Promise((resolve, reject) => {

            var form = new FormData();
            form.append('adminid', adminid);
            form.append('passwd', passwd);
            form.append('passcode', token);
            
            GLOBAL
                .fetchWithCookies(LOGIN_API_URL,
                    {
                        method: "POST",
                        body: form
                    }
                )
                .then(response => {
                    
                    if (response.status === 503) {
                        // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                        reject({
                            error: 'error.503error',
                            message: '伺服器沒有開啟'
                        });

                        return;
                    }

                    response
                        .json()
                        .then(result => {
                            if (!result) {
                                reject();
                                return;
                            }

                            if(result.error) {
                                reject(result.error);
                                return 
                            }

                            dispatch(checkAdminLogin());
                            resolve(result);
                        })
                        .catch(error => {
                            reject(error);
                        });
                })
                .catch(error => {
                    reject(error);
                });
        });

        return promise;

    };
}

function beginAdminLogout(payload) {
    return { type: actionTypes.beginAdminLogout, payload };
}

function logoutDone(payload) {
    return { type: actionTypes.logoutDone, payload };
}

function logout(payload = {}) {
    return dispatch => {

        dispatch(beginAdminLogout(payload)); // dispatch synced action to update loading status

        const promise = new Promise((resolve, reject) => {

            GLOBAL.fetchWithCookies(LOGOUT_API_URL)
                .then(response => {
                    
                    dispatch(logoutDone(payload));
                    resolve(true);

                })
                .catch(error => {
                    
                    dispatch(logoutDone(payload));
                    resolve(error);

                });
        });

        return promise;

    };
}

const adminActions = {
    beginCheckAdminLogin,
    setAdminLoginInfo,
    recvCheckAdminLoginError,
    checkAdminLogin,
    login,
    beginAdminLogout,
    logoutDone,
    logout,
};

export default adminActions;


// WEBPACK FOOTER //
// ./src/actions/creators/adminActions.js